export enum ReceiveRoutes {
  Info = '/receive/info',
  Select = '/receive/select',
}
